<script setup>
import IconOpenInNew from '@/Components/Icons/IconOpenInNew.vue';

defineProps({
  href: String
});
</script>
<template>
  <div
    class="text-primary-600 hover:text-primary-500 flex items-center justify-between gap-2 underline"
  >
    <a :href="href" target="_blank">
      <slot />
    </a>
    <a :href="href" target="_blank">
      <IconOpenInNew :size="16" />
    </a>
  </div>
</template>
